export default __webpack_public_path__ + "static/media/ico_preventivi.68278e7f.svg";